<div class="call-out-container flex flex-col lg:flex-row gap-3 h-full min-h-0">

  <!-- Left Side: Search Filter Form -->
  <div class="left-panel w-full lg:w-80 shrink-0 h-full min-h-0 flex flex-col">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-4 flex flex-col h-fit min-h-0">
      <div class="flex items-center justify-between pb-2.5 mb-2.5 border-b border-gray-100 shrink-0">
        <h2 class="text-sm font-bold text-gray-800 flex items-center gap-2">
          <svg class="w-4 h-4 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          Search Call Outs
        </h2>
        <span class="text-[11px] px-2 py-0.5 font-semibold rounded-full uppercase tracking-wider"
          [ngClass]="pageType === 'cs' ? 'bg-blue-100 text-blue-700' : 'bg-indigo-100 text-indigo-700'">
          {{ pageType === 'cs' ? 'CS Mode' : 'Planning Mode' }}
        </span>
      </div>

      <form class="flex-1 min-h-0 flex flex-col overflow-hidden" (ngSubmit)="searchCallouts()"
        (change)="searchCallouts()">
        <div class="flex-1 min-h-0 overflow-y-auto space-y-2.5 pr-1 custom-scrollbar">

          <!-- Callout Number -->
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-600">Callout Number</label>
            <input type="text"
              class="w-full text-xs px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-gray-50 focus:bg-white"
              [(ngModel)]="callOut_SearchParams.calloutNumber" name="calloutNumber" placeholder="e.g. CO-202609" />
          </div>

          <!-- Job Number -->
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-600">Job Number</label>
            <input type="text"
              class="w-full text-xs px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-gray-50 focus:bg-white"
              [(ngModel)]="callOut_SearchParams.jobNumber" name="jobNumber" placeholder="e.g. PP202609" />
          </div>

          <!-- Customer -->
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-600">Customer</label>
            <input type="text"
              class="w-full text-xs px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-gray-50 focus:bg-white"
              [(ngModel)]="callOut_SearchParams.customer" name="customer" placeholder="e.g. ABC Brands" />
          </div>

          <!-- Status -->
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-600">Status</label>
            <select
              class="w-full text-xs px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-gray-50 focus:bg-white"
              [(ngModel)]="callOut_SearchParams.status" name="status">
              <option value="">All Statuses</option>
              @for (opt of jobStatuses; track opt.id) {
              <option [value]="opt.code">{{ opt.name }}</option>
              }
            </select>
          </div>

          <!-- Week Number -->
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-600">Week Number</label>
            <input type="number"
              class="w-full text-xs px-3 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-gray-50 focus:bg-white"
              [(ngModel)]="callOut_SearchParams.weekNumber" name="weekNumber" placeholder="e.g. 39" />
          </div>

          <!-- Customer Request Date Range -->
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-600">Cus. Request Date Range</label>
            <div class="grid grid-cols-2 gap-2">
              <input type="date"
                class="w-full text-xs px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-gray-50 focus:bg-white"
                [(ngModel)]="callOut_SearchParams.cusRequestStartDate" name="cusRequestStartDate" />
              <input type="date"
                class="w-full text-xs px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-gray-50 focus:bg-white"
                [(ngModel)]="callOut_SearchParams.cusRequestEndDate" name="cusRequestEndDate" />
            </div>
          </div>

          <!-- Planner Confirmed Date Range -->
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-600">Planner Confirmed Date Range</label>
            <div class="grid grid-cols-2 gap-2">
              <input type="date"
                class="w-full text-xs px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-gray-50 focus:bg-white"
                [(ngModel)]="callOut_SearchParams.plannerConfirmedStartDate" name="plannerConfirmedStartDate" />
              <input type="date"
                class="w-full text-xs px-2 py-1.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-gray-50 focus:bg-white"
                [(ngModel)]="callOut_SearchParams.plannerConfirmedEndDate" name="plannerConfirmedEndDate" />
            </div>
          </div>

        </div>

        <!-- Form Actions -->
        <div class="flex gap-2 pt-3 mt-2 border-t border-gray-100 shrink-0">
          <button type="submit"
            class="flex-1 py-2 px-3 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-xs font-semibold rounded-lg shadow-sm transition-all duration-150 flex items-center justify-center gap-1.5 cursor-pointer">
            <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            Search
          </button>
          <button type="button" (click)="resetForm()"
            class="py-2 px-3 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 text-gray-700 text-xs font-semibold rounded-lg transition-all duration-150 cursor-pointer">
            Clear
          </button>
        </div>

      </form>
    </div>
  </div>

  <!-- Right Side: Call Outs Table -->
  <div class="right-panel flex-1 min-w-0 h-full min-h-0 flex flex-col">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden flex flex-col h-full min-h-0">

      <!-- Table Header -->
      <div
        class="px-4 py-3 border-b border-gray-200 flex flex-wrap items-center justify-between gap-3 bg-gray-50 shrink-0">
        <div class="flex items-center gap-2.5">
          <h2 class="text-sm sm:text-base font-bold text-gray-800">Call Out Records</h2>
          <span
            class="text-xs px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-700 font-semibold border border-blue-200">
            {{ $$totalItems() }} total
          </span>
        </div>
      </div>

      <!-- Table Container (Scrollable table body with sticky header) -->
      <div class="overflow-auto flex-1 min-h-0 relative custom-scrollbar">
        <table class="w-full text-xs text-left text-gray-600">
          <thead
            class="text-[11px] text-gray-700 uppercase bg-gray-100 sticky top-0 z-10 border-b border-gray-200 shadow-2xs">
            <tr>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap bg-gray-100">Product Type</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap bg-gray-100">Callout No</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap bg-gray-100">Job No</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap bg-gray-100">Customer</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap text-right bg-gray-100">Call Out Qty</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap text-center bg-gray-100">Week</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap bg-gray-100">Cus. Req. Date</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap bg-gray-100">Planned Date</th>
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap text-center bg-gray-100">Status</th>
              @if(userRole != 'none'){
              <th scope="col" class="px-3.5 py-2.5 whitespace-nowrap text-right bg-gray-100">Action</th>
              }
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            @if (callOutSearchResult.length > 0) {
            @for (item of callOutSearchResult; track item.id) {
            <tr class="hover:bg-blue-50/40 transition-colors">
              <td class="px-3.5 py-2.5 font-semibold text-gray-500 whitespace-nowrap">{{ item.productType}}
              </td>
              <td class="px-3.5 py-2.5 font-semibold text-gray-900 whitespace-nowrap">{{ item.calloutNumber || item.id
                }}
              </td>
              <td class="px-3.5 py-2.5 font-medium text-blue-700 whitespace-nowrap">{{ item.jobNumber }}</td>
              <td class="px-3.5 py-2.5 font-medium text-gray-800 whitespace-nowrap">{{ item.customer || '-' }}</td>
              <td class="px-3.5 py-2.5 text-right font-bold text-gray-900 whitespace-nowrap">{{ item.callOutQty | number
                }}</td>
              <td class="px-3.5 py-2.5 text-center whitespace-nowrap">{{ item.weekNumber || '-' }}</td>
              <td class="px-3.5 py-2.5 whitespace-nowrap">{{ item.cusRequestDate || '-' }}</td>
              <td class="px-3.5 py-2.5 whitespace-nowrap font-medium"
                [class.text-emerald-700]="item.plannerConfirmedDate">{{ item.plannerConfirmedDate || '-' }}</td>
              <td class="px-3.5 py-2.5 text-center whitespace-nowrap">
                <span
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold border capitalize"
                  [ngClass]="getStatusClass(item.status)">
                  {{ item.status }}
                </span>
              </td>
              @if(userRole != 'none'){
              <td class="px-3.5 py-2.5 text-right whitespace-nowrap">
                @if (pageType === 'cs') {
                <button type="button"
                  class="px-2.5 py-1 text-xs font-semibold text-blue-700 bg-blue-50 border border-blue-200 hover:bg-blue-100 rounded-lg transition-colors cursor-pointer"
                  (click)="prepareDataForCallout(item)">
                  {{ item.status === 'pending' || item.status === 'rejected' ? 'Edit Callout' : 'View Callout' }}
                </button>
                } @else {
                <button type="button"
                  class="px-2.5 py-1 text-xs font-semibold text-indigo-700 bg-indigo-50 border border-indigo-200 hover:bg-indigo-100 rounded-lg transition-colors cursor-pointer"
                  (click)="prepareDataForCallout(item)">
                  {{ item.status === 'pending' ? 'Review Callout' : 'View Callout' }}
                </button>
                }
              </td>
              }

            </tr>
            }
            } @else {
            <tr>
              <td colspan="12" class="px-4 py-12 text-center text-gray-400">
                <div class="flex flex-col items-center justify-center space-y-2">
                  <svg class="w-8 h-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <p class="text-sm font-medium">No callout records found.</p>
                  <p class="text-xs text-gray-400">Try adjusting your search criteria.</p>
                </div>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Table Footer / Pagination -->
      <div class="shrink-0 border-t border-gray-200 bg-gray-50/60 px-4 py-2 flex items-center justify-between">
        <app-pagination class="w-full" [totalItems]="$$totalItems()" [itemsPerPage]="$$itemsPerPage()"
          (pageChanged)="onPageChange($event)"></app-pagination>
      </div>

    </div>
  </div>

</div>

<!-- ================= Modal: Callout Edit / Review Modal ================= -->
@if (isCallOffForm && calloutObject) {
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 backdrop-blur-xs p-3 sm:p-6 overflow-y-auto">
  <div
    class="relative bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-4xl max-h-[92vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-150">

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-xl flex items-center justify-center font-bold"
          [ngClass]="pageType === 'cs' ? 'bg-blue-100 text-blue-700' : 'bg-indigo-100 text-indigo-700'">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        </div>
        <div>
          <div class="flex items-center gap-2">
            <h3 class="text-base font-bold text-gray-800">{{ calloutObject.calloutNumber || 'Call Out Details' }}</h3>
            <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border capitalize"
              [ngClass]="getStatusClass(calloutObject.status)">
              {{ calloutObject.status }}
            </span>
          </div>
          <p class="text-xs text-gray-500 font-medium">
            {{ pageType === 'cs' ? 'Customer Service Callout Amendment' : 'Planning Team Delivery Confirmation' }}
          </p>
        </div>
      </div>
      <button type="button" (click)="closeCallOffForm()"
        class="text-gray-400 hover:text-gray-600 hover:bg-gray-200 rounded-lg p-1.5 transition-colors cursor-pointer">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Modal Body (All inputs displayed, conditionally disabled) -->
    <div class="p-6 overflow-y-auto space-y-6">

      <!-- Status Guidance Banner -->
      @if (calloutObject.status === 'approved') {
      <div
        class="p-3 bg-emerald-50 border border-emerald-200 rounded-xl flex items-center gap-2.5 text-xs text-emerald-800">
        <svg class="w-4 h-4 text-emerald-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>This callout is <strong>Approved</strong>. All amendments are permanently blocked.</span>
      </div>
      } @else if (calloutObject.status === 'cancelled') {
      <div class="p-3 bg-red-50 border border-red-200 rounded-xl flex items-center gap-2.5 text-xs text-red-800">
        <svg class="w-4 h-4 text-red-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>This callout is <strong>Cancelled</strong>. All amendments are blocked.</span>
      </div>
      } @else if (calloutObject.status === 'rejected') {
      <div class="p-3 bg-amber-50 border border-amber-200 rounded-xl flex items-center gap-2.5 text-xs text-amber-800">
        <svg class="w-4 h-4 text-amber-600 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span>This callout is <strong>Rejected</strong>. CS can amend the callout quantity and requested date to
          resubmit.</span>
      </div>
      }

      <!-- Job Callout Summary Card -->
      @if (isLoadingSummary) {
      <div
        class="p-3 bg-blue-50/50 border border-blue-100 rounded-xl flex items-center justify-center gap-2 text-xs text-blue-600 animate-pulse">
        <svg class="w-4 h-4 animate-spin text-blue-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        <span>Loading summary for Job <strong>{{ calloutObject.jobNumber }}</strong>...</span>
      </div>
      } @else if (jobCalloutSummary) {
      <div
        class="bg-gradient-to-r from-blue-50/60 via-indigo-50/40 to-slate-50/60 border border-blue-200/80 rounded-xl p-3.5 shadow-2xs">
        <div class="flex items-center justify-between pb-2.5 mb-2.5 border-b border-blue-200/60">
          <div class="flex items-center gap-2">
            <svg class="w-4 h-4 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            <span class="text-xs font-bold text-gray-800 uppercase tracking-wider">Job Callout Summary</span>
          </div>
          <span class="text-xs font-bold text-blue-900 bg-blue-100 px-2.5 py-0.5 rounded-full border border-blue-200">
            {{ jobCalloutSummary.jobNumber }}
          </span>
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5">
          <!-- Job Quantity -->
          <div class="bg-white p-2.5 rounded-lg border border-gray-200 shadow-2xs flex flex-col">
            <span class="text-[10px] font-bold text-gray-500 uppercase tracking-wide">Job Quantity</span>
            <span class="text-sm font-extrabold text-gray-900 mt-0.5">{{ jobCalloutSummary.jobQuantity | number
              }}</span>
          </div>

          <!-- Pending Quantity -->
          <div class="bg-amber-50/80 p-2.5 rounded-lg border border-amber-200 shadow-2xs flex flex-col">
            <span
              class="text-[10px] font-bold text-amber-800 uppercase tracking-wide flex items-center justify-between">
              <span>Pending</span>
              <span class="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
            </span>
            <span class="text-sm font-extrabold text-amber-900 mt-0.5">{{ jobCalloutSummary.pendingQuantity | number
              }}</span>
          </div>

          <!-- Approved Quantity -->
          <div class="bg-emerald-50/80 p-2.5 rounded-lg border border-emerald-200 shadow-2xs flex flex-col">
            <span
              class="text-[10px] font-bold text-emerald-800 uppercase tracking-wide flex items-center justify-between">
              <span>Approved</span>
              <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
            </span>
            <span class="text-sm font-extrabold text-emerald-900 mt-0.5">{{ jobCalloutSummary.approvedQuantity | number
              }}</span>
          </div>

          <!-- Rejected Quantity -->
          <div class="bg-rose-50/80 p-2.5 rounded-lg border border-rose-200 shadow-2xs flex flex-col">
            <span class="text-[10px] font-bold text-rose-800 uppercase tracking-wide flex items-center justify-between">
              <span>Rejected</span>
              <span class="w-1.5 h-1.5 rounded-full bg-rose-500"></span>
            </span>
            <span class="text-sm font-extrabold text-rose-900 mt-0.5">{{ jobCalloutSummary.rejectedQuantity | number
              }}</span>
          </div>

          <!-- Cancelled Quantity -->
          <div
            class="bg-gray-100/90 p-2.5 rounded-lg border border-gray-300 shadow-2xs flex flex-col col-span-2 sm:col-span-1">
            <span class="text-[10px] font-bold text-gray-600 uppercase tracking-wide flex items-center justify-between">
              <span>Cancelled</span>
              <span class="w-1.5 h-1.5 rounded-full bg-gray-400"></span>
            </span>
            <span class="text-sm font-extrabold text-gray-700 mt-0.5">{{ jobCalloutSummary.cancelledQuantity | number
              }}</span>
          </div>
        </div>
      </div>
      }

      <!-- Unified Callout Form Grid (No inputs hidden) -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">

        <!-- Job Number (Always Disabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Job Number</label>
          <input type="text"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            [value]="calloutObject.jobNumber" disabled />
        </div>

        <!-- Customer Name (Always Disabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Customer</label>
          <input type="text"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            [value]="calloutObject.customer" disabled />
        </div>

        <!-- Call Out Quantity (Editable by CS when Pending/Rejected) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center justify-between text-xs font-semibold text-gray-700">
            <span class="flex items-center gap-1">Call Out Quantity <span class="text-red-500">*</span></span>
            @if (isCsEditable()) {
            <span class="text-[10px] text-blue-600 font-normal">Editable</span>
            }
          </label>
          <input type="number"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-500 font-bold"
            [(ngModel)]="calloutObject.callOutQuantity" (click)="selectAll($event)" [disabled]="!isCsEditable()"
            min="1" />
        </div>

        <!-- Customer Request Date (Editable by CS when Pending/Rejected) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center justify-between text-xs font-semibold text-gray-700">
            <span class="flex items-center gap-1">Customer Request Date <span class="text-red-500">*</span></span>
            @if (isCsEditable()) {
            <span class="text-[10px] text-blue-600 font-normal">Editable</span>
            }
          </label>
          <input type="date"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-500 font-medium"
            [(ngModel)]="calloutObject.customerRequestedDate" [min]="minDate" [disabled]="!isCsEditable()" />
        </div>

        <!-- Week Number (Editable by CS when Pending/Rejected) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center justify-between text-xs font-semibold text-gray-700">
            <span>Week Number</span>
            @if (isCsEditable()) {
            <span class="text-[10px] text-blue-600 font-normal">Editable</span>
            }
          </label>
          <input type="number"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-500 font-medium"
            [(ngModel)]="calloutObject.weekNumber" (click)="selectAll($event)" [disabled]="!isCsEditable()"
            placeholder="e.g. 39" />
        </div>

        <!-- Planner Confirmed Date (Editable only by Planner when Pending) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center justify-between text-xs font-semibold text-gray-700">
            <span>Planner Confirmed Date</span>
            @if (isPlannerEditable()) {
            <span class="text-[10px] text-indigo-600 font-bold">Planner Action</span>
            }
          </label>
          <input type="date"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-500 font-medium"
            [(ngModel)]="calloutObject.plannerConfirmedDate" [min]="minDate" [disabled]="!isPlannerEditable()" />
        </div>

        <!-- Delivered Quantity (Always Disabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Delivered Quantity</label>
          <input type="number"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            [value]="calloutObject.deliveredQuantity" disabled />
        </div>

        <!-- Last Dispatch Number (Always Disabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Last Dispatch Number</label>
          <input type="text"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            [value]="calloutObject.lastDispatchNumber || '-'" disabled />
        </div>

        <!-- Last Dispatch Date (Always Disabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Last Dispatch Date</label>
          <input type="text"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            [value]="calloutObject.LastDispatchDate || '-'" disabled />
        </div>

      </div>

      <!-- Dispatch Details / Dispatch Numbers List -->
      @if (calloutObject.dispatchNumbers && calloutObject.dispatchNumbers.length > 0) {
      <div class="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-xs">
        <div class="px-4 py-2.5 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
          <div class="flex items-center gap-2">
            <svg class="w-4 h-4 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
            </svg>
            <span class="text-xs font-bold text-gray-800">Dispatch Numbers</span>
          </div>
          <span
            class="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200">
            {{ calloutObject.dispatchNumbers.length }} {{ calloutObject.dispatchNumbers.length === 1 ? 'Dispatch' :
            'Dispatches' }}
          </span>
        </div>
        <div class="overflow-x-auto">
          <table class="w-full text-xs text-left">
            <thead class="text-[11px] text-gray-700 uppercase bg-gray-100/80 border-b border-gray-200">
              <tr>
                <th scope="col" class="px-4 py-2.5 font-semibold">#</th>
                <th scope="col" class="px-4 py-2.5 font-semibold">Dispatch Number</th>
                <th scope="col" class="px-4 py-2.5 font-semibold">Date</th>
                <th scope="col" class="px-4 py-2.5 font-semibold text-right">Quantity</th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              @for (disp of calloutObject.dispatchNumbers; track $index) {
              <tr class="hover:bg-blue-50/40 transition-colors">
                <td class="px-4 py-2.5 text-gray-400 font-medium">{{ $index + 1 }}</td>
                <td class="px-4 py-2.5 font-bold text-blue-700 whitespace-nowrap">{{ disp.number || '-' }}</td>
                <td class="px-4 py-2.5 text-gray-700 whitespace-nowrap">{{ disp.date || '-' }}</td>
                <td class="px-4 py-2.5 text-right font-bold text-gray-900 whitespace-nowrap">{{ disp.qty }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      }

    </div>

    <!-- Modal Footer / Actions -->
    <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-end gap-3">
      <button type="button" (click)="closeCallOffForm()"
        class="px-4 py-2 text-xs font-semibold text-gray-600 hover:text-gray-800 bg-white border border-gray-300 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
        Close
      </button>

      <!-- Planning Actions -->
      @if (pageType === 'planning') {
      <button type="button" (click)="promptRejectCallout()" [disabled]="!isPlanningRejectable()"
        class="px-4 py-2 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 active:bg-red-800 rounded-lg shadow-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer">
        Reject Callout
      </button>

      <button type="button" (click)="approveCallout()" [disabled]="!isPlanningApprovable()"
        class="px-5 py-2 text-xs font-semibold text-white bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 rounded-lg shadow-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-1.5 cursor-pointer">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Approve Callout
      </button>
      } @else {
      <!-- CS Actions -->
      <button type="button" (click)="promptCancelCallout()" [disabled]="!isCsCancelable()"
        class="px-4 py-2 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 active:bg-red-800 rounded-lg shadow-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer">
        Cancel Callout
      </button>

      <button type="button" (click)="updateCallOffData()" [disabled]="!isCsEditable()"
        class="px-5 py-2 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-lg shadow-sm transition-colors disabled:opacity-40 disabled:cursor-not-allowed flex items-center gap-1.5 cursor-pointer">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
        Update Callout
      </button>
      }
    </div>

  </div>
</div>
}

<!-- ================= Confirmation Modal ================= -->
@if (isConfirmModalOpen) {
<div
  class="confirmation-modal-overlay fixed inset-0 flex items-center justify-center bg-gray-900/70 backdrop-blur-sm p-4"
  style="z-index: 99999 !important;">
  <div
    class="confirmation-modal-card relative bg-white rounded-xl shadow-2xl border border-gray-200 w-full max-w-sm p-5 space-y-4 animate-in fade-in zoom-in duration-150"
    style="z-index: 100000 !important;">
    <div class="flex items-center gap-3">
      <div class="p-2 rounded-full bg-red-100 text-red-600 shrink-0">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h4 class="text-sm font-bold text-gray-800">{{ confirmModalTitle }}</h4>
    </div>
    <p class="text-xs text-gray-600 leading-relaxed">{{ confirmModalMessage }}</p>
    <div class="flex items-center justify-end gap-2 pt-2">
      <button type="button" (click)="onCancelConfirmAction()"
        class="px-3.5 py-1.5 text-xs font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer">
        No, Keep it
      </button>
      <button type="button" (click)="onConfirmAction()"
        class="px-4 py-1.5 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg shadow-sm transition-colors cursor-pointer">
        Yes, Proceed
      </button>
    </div>
  </div>
</div>
}

<!-- ================= Create New Call Out Modal ================= -->
@if (isCreateCalloutModalOpen) {
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 backdrop-blur-xs p-3 sm:p-6 overflow-y-auto">
  <div
    class="relative bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-5xl max-h-[92vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-150">

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-gray-50">
      <div class="flex items-center gap-3">
        <div class="w-9 h-9 rounded-xl bg-blue-100 text-blue-700 flex items-center justify-center font-bold">
          <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
          </svg>
        </div>
        <div>
          <h3 class="text-base font-bold text-gray-800">Create New Call Out</h3>
          <p class="text-xs text-gray-500 font-medium">
            {{ selectedJob ? 'Step 2: Enter Callout Details' : 'Step 1: Search & Select Job Card' }}
          </p>
        </div>
      </div>
      <button type="button" (click)="closeCreateModal()"
        class="text-gray-400 hover:text-gray-600 hover:bg-gray-200 rounded-lg p-1.5 transition-colors cursor-pointer">
        <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="p-6 overflow-y-auto space-y-5">

      <!-- ============ Step 1: Job Search & Selection ============ -->
      @if (!selectedJob) {

      <!-- Search Bar -->
      <div class="bg-gray-50 p-4 rounded-xl border border-gray-200 space-y-3">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-700">Job Number (PP No)</label>
            <input type="text"
              class="w-full text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white"
              [(ngModel)]="jobSearchInput.pp_number" placeholder="e.g. PP202609/0001234" (keyup.enter)="searchJobs()" />
          </div>
          <div class="space-y-1">
            <label class="text-xs font-semibold text-gray-700">Customer</label>
            <input type="text"
              class="w-full text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white"
              [(ngModel)]="jobSearchInput.customer" placeholder="Search by customer name..."
              (keyup.enter)="searchJobs()" />
          </div>
        </div>
        <div class="flex justify-end pt-1">
          <button type="button" (click)="searchJobs()" [disabled]="isSearchingJobs"
            class="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-xs font-bold rounded-lg shadow-sm transition-colors flex items-center gap-2 disabled:opacity-50 cursor-pointer">
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            Search Jobs
          </button>
        </div>
      </div>

      <!-- Job Search Results Table (Scrollable horizontally) -->
      <div class="rounded-xl border border-gray-200 overflow-x-auto shadow-xs bg-white">
        <table class="w-full text-xs text-left min-w-[720px]">
          <thead class="text-[11px] text-gray-700 uppercase bg-gray-100/90 border-b border-gray-200 sticky top-0">
            <tr>
              <th class="px-4 py-3 whitespace-nowrap">Job Number</th>
              <th class="px-4 py-3 whitespace-nowrap">Customer</th>
              <th class="px-4 py-3 min-w-[200px]">Description</th>
              <th class="px-4 py-3 text-right whitespace-nowrap">Quantity</th>
              <th class="px-4 py-3 text-right whitespace-nowrap min-w-[120px]">Action</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            @if (jobSearchResults.length > 0) {
            @for (job of jobSearchResults; track job.jobCardId) {
            <tr class="hover:bg-blue-50/60 transition-colors">
              <td class="px-4 py-3 font-bold text-blue-700 whitespace-nowrap">{{ job.ppNo }}</td>
              <td class="px-4 py-3 font-medium text-gray-800 whitespace-nowrap">{{ job.customer || '-' }}</td>
              <td class="px-4 py-3 text-gray-600 max-w-sm truncate" [title]="job.description || ''">{{ job.description
                || '-' }}</td>
              <td class="px-4 py-3 text-right font-bold text-gray-900 whitespace-nowrap">{{ job.quantity | number }}
              </td>
              <td class="px-4 py-3 text-right whitespace-nowrap">
                <button type="button" (click)="selectJob(job)"
                  class="px-3.5 py-1.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-bold rounded-lg text-xs shadow-xs transition-colors flex items-center gap-1.5 ml-auto cursor-pointer">
                  <svg class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4" />
                  </svg>
                  Select & Add
                </button>
              </td>
            </tr>
            }
            } @else if (hasSearchedJobs && !isSearchingJobs) {
            <tr>
              <td colspan="5" class="px-4 py-12 text-center text-gray-400">
                <p class="text-sm font-medium">No matching jobs found.</p>
                <p class="text-xs text-gray-400">Try searching with a different Job Number or Customer.</p>
              </td>
            </tr>
            } @else {
            <tr>
              <td colspan="5" class="px-4 py-10 text-center text-gray-400">
                <p class="text-xs">Search for a job by PP Number or Customer above to get started.</p>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      } @else {

      <!-- ============ Step 2: Selected Job & Unified Callout Details Form ============ -->

      <!-- Selected Job Card -->
      <div
        class="bg-blue-50/80 border border-blue-200 rounded-xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div class="space-y-1">
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold text-blue-900">Selected Job:</span>
            <span class="text-sm font-extrabold text-blue-700">{{ selectedJob.ppNo }}</span>
            <span class="text-[11px] px-2 py-0.5 rounded bg-blue-200/70 text-blue-800 font-semibold">{{
              selectedJob.customer }}</span>
          </div>
          <p class="text-xs text-gray-700 font-medium">{{ selectedJob.description }}</p>
          <p class="text-xs text-gray-500">Total Job Quantity: <strong class="text-gray-800">{{
              (jobCalloutSummary?.jobQuantity ?? 0) |
              number }}</strong></p>
        </div>
        <button type="button" (click)="resetSelectedJob()"
          class="px-3 py-1.5 text-xs font-semibold text-blue-700 bg-white border border-blue-300 hover:bg-blue-100 rounded-lg transition-colors shrink-0 cursor-pointer">
          Change Job
        </button>
      </div>

      <!-- Job Callout Summary Card (Create Mode) -->
      @if (isLoadingSummary) {
      <div
        class="p-3 bg-blue-50/50 border border-blue-100 rounded-xl flex items-center justify-center gap-2 text-xs text-blue-600 animate-pulse">
        <svg class="w-4 h-4 animate-spin text-blue-600" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
          </path>
        </svg>
        <span>Loading callout summary for Job <strong>{{ selectedJob.ppNo }}</strong>...</span>
      </div>
      } @else if (jobCalloutSummary) {
      <div
        class="bg-gradient-to-r from-blue-50/60 via-indigo-50/40 to-slate-50/60 border border-blue-200/80 rounded-xl p-3.5 shadow-2xs">
        <div class="flex items-center justify-between pb-2.5 mb-2.5 border-b border-blue-200/60">
          <div class="flex items-center gap-2">
            <svg class="w-4 h-4 text-blue-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            <span class="text-xs font-bold text-gray-800 uppercase tracking-wider">Job Callout Summary</span>
          </div>
          <span class="text-xs font-bold text-blue-900 bg-blue-100 px-2.5 py-0.5 rounded-full border border-blue-200">
            {{ jobCalloutSummary.jobNumber }}
          </span>
        </div>

        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2.5">
          <!-- Job Quantity -->
          <div class="bg-white p-2.5 rounded-lg border border-gray-200 shadow-2xs flex flex-col">
            <span class="text-[10px] font-bold text-gray-500 uppercase tracking-wide">Job Quantity</span>
            <span class="text-sm font-extrabold text-gray-900 mt-0.5">{{ jobCalloutSummary.jobQuantity | number
              }}</span>
          </div>

          <!-- Pending Quantity -->
          <div class="bg-amber-50/80 p-2.5 rounded-lg border border-amber-200 shadow-2xs flex flex-col">
            <span
              class="text-[10px] font-bold text-amber-800 uppercase tracking-wide flex items-center justify-between">
              <span>Pending</span>
              <span class="w-1.5 h-1.5 rounded-full bg-amber-500"></span>
            </span>
            <span class="text-sm font-extrabold text-amber-900 mt-0.5">{{ jobCalloutSummary.pendingQuantity | number
              }}</span>
          </div>

          <!-- Approved Quantity -->
          <div class="bg-emerald-50/80 p-2.5 rounded-lg border border-emerald-200 shadow-2xs flex flex-col">
            <span
              class="text-[10px] font-bold text-emerald-800 uppercase tracking-wide flex items-center justify-between">
              <span>Approved</span>
              <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
            </span>
            <span class="text-sm font-extrabold text-emerald-900 mt-0.5">{{ jobCalloutSummary.approvedQuantity | number
              }}</span>
          </div>

          <!-- Rejected Quantity -->
          <div class="bg-rose-50/80 p-2.5 rounded-lg border border-rose-200 shadow-2xs flex flex-col">
            <span class="text-[10px] font-bold text-rose-800 uppercase tracking-wide flex items-center justify-between">
              <span>Rejected</span>
              <span class="w-1.5 h-1.5 rounded-full bg-rose-500"></span>
            </span>
            <span class="text-sm font-extrabold text-rose-900 mt-0.5">{{ jobCalloutSummary.rejectedQuantity | number
              }}</span>
          </div>

          <!-- Cancelled Quantity -->
          <div
            class="bg-gray-100/90 p-2.5 rounded-lg border border-gray-300 shadow-2xs flex flex-col col-span-2 sm:col-span-1">
            <span class="text-[10px] font-bold text-gray-600 uppercase tracking-wide flex items-center justify-between">
              <span>Cancelled</span>
              <span class="w-1.5 h-1.5 rounded-full bg-gray-400"></span>
            </span>
            <span class="text-sm font-extrabold text-gray-700 mt-0.5">{{ jobCalloutSummary.cancelledQuantity | number
              }}</span>
          </div>
        </div>
      </div>
      }

      <!-- All Callout Inputs Rendered in Create Mode (None hidden) -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-2">

        <!-- Job Number (Disabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Job Number</label>
          <input type="text"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            [value]="selectedJob.ppNo" disabled />
        </div>

        <!-- Customer Name (Disabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Customer</label>
          <input type="text"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            [value]="selectedJob.customer" disabled />
        </div>

        <!-- Call Out Quantity (Enabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center gap-1 text-xs font-semibold text-gray-700">
            <span>Call Out Quantity</span>
            <span class="text-red-500">*</span>
          </label>
          <input type="number"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white font-bold"
            [(ngModel)]="newCalloutForm.callOutQty" name="createCallOutQty" placeholder="Enter quantity" min="1" />
        </div>

        <!-- Customer Requested Date (Enabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center gap-1 text-xs font-semibold text-gray-700">
            <span>Customer Req. Date</span>
            <span class="text-red-500">*</span>
          </label>
          <input type="date"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white font-medium"
            [(ngModel)]="newCalloutForm.customerRequestedDate" [min]="minDate" name="createCusReqDate" />
        </div>

        <!-- Week Number (Enabled) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Week Number</label>
          <input type="number"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-white font-medium"
            [(ngModel)]="newCalloutForm.weekNumber" name="createWeekNumber" placeholder="e.g. 39" />
        </div>

        <!-- Planner Confirmed Date (Disabled for Create) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Planner Confirmed Date</label>
          <input type="text"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-400 cursor-not-allowed"
            value="Pending Planner Confirmation" disabled />
        </div>

        <!-- Delivered Quantity (Disabled for Create) -->
        <div class="space-y-1.5">
          <label class="h-5 flex items-center text-xs font-semibold text-gray-700">Delivered Quantity</label>
          <input type="number"
            class="w-full h-[38px] text-xs px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-700 cursor-not-allowed font-medium"
            value="0" disabled />
        </div>

      </div>

      <!-- Initial Status Info -->
      <div class="flex items-center gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200 text-xs text-gray-600">
        <span class="font-semibold text-gray-700">Initial Status:</span>
        <span
          class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-yellow-100 text-yellow-800 border border-yellow-300">
          Pending
        </span>
        <span class="text-gray-400 text-[11px]">(Will be automatically submitted with pending status for Planning
          review)</span>
      </div>

      }

    </div>

    <!-- Modal Footer -->
    <div class="px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-end gap-3">
      <button type="button" (click)="closeCreateModal()"
        class="px-4 py-2 text-xs font-semibold text-gray-600 hover:text-gray-800 bg-white border border-gray-300 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
        Cancel
      </button>

      @if (selectedJob) {
      <button type="button" (click)="submitCreateCallout()"
        [disabled]="!newCalloutForm.callOutQty || !newCalloutForm.customerRequestedDate"
        class="px-5 py-2 text-xs font-semibold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 rounded-lg shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1.5 cursor-pointer">
        <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
        Create Call Out
      </button>
      }
    </div>

  </div>
</div>
}